// Pure tile-source resolution, split out of `MapLibreEditorCanvas.tsx` so it's
// unit-testable without rendering a `MapView` (whose fake doesn't expose
// `baseSource`/`overlaySources` on the DOM — there is nothing there for a
// consumer test to assert against otherwise).

import { tangerRasterSource, type RasterSourceSpec } from '@wehunt/map'

/** The editor's base tile source, or `null` before the catalogue has
 *  answered. `widths: []` — same as every other migrated map surface
 *  (`StandsMap`, `ReportMap`): the honest zoom-bounds pattern reads the
 *  catalogue's real fetch bounds off `tileInfo.minZ`/`maxZ` via
 *  `tangerRasterSource`, rather than a tile-width preference this canvas
 *  doesn't have an opinion on. */
export function resolveBaseSource(tileInfo: { url: string; generation: number; minZ?: number; maxZ?: number } | null): RasterSourceSpec | null {
  return tileInfo ? tangerRasterSource({ ...tileInfo, widths: [] }) : null
}

/** Transparent overlay rasters, composited above the base in list order —
 *  same `widths: []` convention as {@link resolveBaseSource}. */
export function resolveOverlaySources(
  overlayLayers: readonly { url: string; generation: number; minZ?: number; maxZ?: number }[],
): RasterSourceSpec[] {
  return overlayLayers.map((layer) => tangerRasterSource({ ...layer, widths: [] }))
}
